import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  editSubCategory: [],
  loading: false,
  error: null,
};

const editSubCategorySlice = createSlice({
  name: "editSubCategory",

  initialState,

  reducers: {
    fetchEditSubCategorySuccess: (state, action) => {
      state.loading = false;
      state.editSubCategory = action.payload;
    },

    fetchEditSubCategoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchEditSubCategorySuccess,
  fetchEditSubCategoryFailure,
} = editSubCategorySlice.actions;

export default editSubCategorySlice.reducer;